/* global jQuery */

import { isFDA, isLegacyFDA } from "./format.js";

export const NUTRITION_FACTS_PANEL_SELECTOR = "#label > div:not(.label-preamble)";

/* Human-initiated events have an originalEvent from the DOM.  `trigger("click")` does not,
   and is a synthetic event. */
export const syntheticEvent = (jqueryEvent) => {
  return !jqueryEvent.originalEvent;
};

export const clickUnlessChecked = (element) => {
  element = jQuery(element);
  if (!element.is(":checked")) {
    element.trigger("click");
  }
};

/* Execute a function with fades, etc disabled.  Prevents some slow load-time animations */
export const withoutFx = (fn) => {
  const saved = jQuery.fx.off;
  jQuery.fx.off = true;
  try {
    fn();
  } finally {
    jQuery.fx.off = saved;
  }
};

export const withSectionExpanded = (section, fn) => {
  const e = jQuery(section);
  const saved = e.is(":visible");
  e.show();

  const result = fn();

  if (!saved) {
    e.hide();
  }

  return result;
};

export const idleCallback = (fn) => {
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(fn);
  } else {
    setTimeout(fn);
  }
};

/**
 * Initialize a jQuery UI slider and accompanying text value.
 */
export const initializeSlider = ({
  selector,
  inputSelector,
  valueSelector,
  defaultValue,
  min,
  max,
  step,
  formatValue = (value) => value,
  onSlide = null,
  onChange = null,
  onStop = null,
}) => {
  const slider = jQuery(selector);
  if (!slider.length) return; // nothing to init yet
  if (slider.hasClass("ui-slider")) return; // Already initialized, skip
  const inputVal = jQuery(inputSelector).val();
  const value = parseFloat(inputVal ?? defaultValue);

  // Update display value
  jQuery(valueSelector).text(formatValue(value));

  const handleChange = (_event, ui) => {
    jQuery(inputSelector).val(ui.value);
    jQuery(valueSelector).text(formatValue(ui.value));

    // Call additional callbacks if provided
    if (typeof onSlide === "function") {
      onSlide(ui);
    }
  };

  try {
    slider.slider({
      step,
      value,
      min,
      max,
      slide: handleChange,
      change: (event, ui) => {
        handleChange(event, ui);
        if (typeof onChange === "function") {
          onChange(ui);
        }
      },
      stop: (event, ui) => {
        // When sliding stops, call the onStop callback if provided
        if (typeof onStop === "function") {
          onStop(ui);
        } else {
          // Default behavior is to just call handleChange
          handleChange(event, ui);
        }
      },
    });
  } catch (e) {
    console.warn(`Error initializing slider ${selector}:`, e);
  }
};

export const getLocales = () => {
  if (isFDA() || isLegacyFDA()) {
    return ["en-US"];
  }

  if (document.querySelector("#canada-english-only-toggle").checked) {
    return ["en-CA"];
  } else if (document.querySelector("#canada-french-only-toggle").checked) {
    return ["fr-CA"];
  } else {
    return document.querySelector("#reverse-language-toggle").checked
      ? ["fr-CA", "en-CA"]
      : ["en-CA", "fr-CA"];
  }
};

export const getLanguages = () => {
  const languageMap = {
    "en-US": "en",
    "en-CA": "en",
    "fr-CA": "fr",
  };

  return getLocales().map((locale) => languageMap[locale]);
};
